var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable max-lines */
import React, { forwardRef, useEffect, useImperativeHandle, useState, } from 'react';
import { buildUniqueId, useCFAccordion, } from '@connectrn/ds-ui-base';
import { CFDivider } from '../../components';
import { useCFAnimatedHeight, useCFTestID } from '../../hooks';
import { CFAccordionElements } from './Accordion.styles';
import { CFAccordionTrigger } from './AccordionTrigger';
export const CFAccordionCore = (_a, ref) => {
    var { bordered = true, children, customTrigger, extendIntoGutters, dividerAbove, dividerBelow, fullWidth, id, label, onChange, onClickTrigger, panelActive = false } = _a, rest = __rest(_a, ["bordered", "children", "customTrigger", "extendIntoGutters", "dividerAbove", "dividerBelow", "fullWidth", "id", "label", "onChange", "onClickTrigger", "panelActive"]);
    const { commonAttrs, elementTestID, elementTestIDString } = useCFTestID('cf-accordion', rest);
    const [internalId, setInternalId] = useState(id || buildUniqueId('accordion', (Math.random() * 100).toString()));
    const { Divider, Panel, Root, Trigger } = CFAccordionElements;
    const getContent = () => {
        return React.createElement(Panel, null, children);
    };
    const { animatedContent, change } = useCFAnimatedHeight({
        content: getContent(),
        height: panelActive ? 'auto' : 0,
    });
    const { active, setActive, toggle } = useCFAccordion(panelActive, {
        onChange: (active) => {
            if (onChange)
                onChange(internalId, active);
        },
        onStartHide: () => {
            change({ height: 0 });
        },
        onStartReveal: () => {
            change({ height: 'auto' });
        },
    });
    const clickTrigger = () => {
        const newActive = toggle();
        if (onClickTrigger)
            onClickTrigger(internalId, newActive);
    };
    useImperativeHandle(ref, () => {
        return {
            active,
            id: internalId,
            setActive,
            toggle,
        };
    });
    useEffect(() => {
        setInternalId(id || buildUniqueId('accordion', (Math.random() * 100).toString()));
    }, [id]);
    useEffect(() => {
        change({ content: getContent() });
    }, [children]);
    useEffect(() => {
        if (panelActive !== active)
            setActive(panelActive);
    }, [panelActive]);
    return (React.createElement(Root, Object.assign({ "$bordered": bordered, "$extendIntoGutters": extendIntoGutters, "$fullWidth": fullWidth }, commonAttrs),
        React.createElement(Trigger, Object.assign({ "$fullWidth": fullWidth, onClick: clickTrigger }, elementTestID('trigger-wrapper')), customTrigger ? customTrigger : (React.createElement(CFAccordionTrigger, { fullWidth: fullWidth, label: label, panelActive: active, testID: elementTestIDString('trigger') }))),
        animatedContent(),
        dividerAbove && (React.createElement(Divider, { "aria-hidden": 'true', "$position": 'top', "$fullWidth": fullWidth },
            React.createElement(CFDivider, null))),
        dividerBelow && (React.createElement(Divider, { "aria-hidden": 'true', "$position": 'bottom', "$fullWidth": fullWidth },
            React.createElement(CFDivider, null)))));
};
export const CFAccordion = forwardRef(CFAccordionCore);
